import { render, staticRenderFns } from "./CommunitySelect.vue?vue&type=template&id=7a8ba870&scoped=true"
import script from "./CommunitySelect.vue?vue&type=script&lang=js"
export * from "./CommunitySelect.vue?vue&type=script&lang=js"
import style0 from "./CommunitySelect.vue?vue&type=style&index=0&id=7a8ba870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8ba870",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemActionText } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItemAction,VListItemActionText,VListItemContent,VListItemIcon,VListItemTitle})
